<script setup lang="ts">
import ButtonText from '@/shared/components/UI/Buttons/ButtonText.vue';
import IconChevron from '@/shared/components/UI/Icons/IconChevron.vue';
import IconDownload from '@/shared/components/UI/Icons/IconDownload.vue';
import Modal from '@/shared/components/UI/Modal.vue';
import { useTranslations } from '@/shared/composables/useTranslations';

const { t } = useTranslations();

defineProps<{
  active: boolean;
  loading?: boolean;
  error?: string | null;
}>();

const emit = defineEmits<{
  'update:active': [value: boolean];
  'save-to-stash': [];
  'just-pdf': [];
}>();
</script>

<template>
  <Modal
    :active="active"
    :size="'md'"
    @update:active="emit('update:active', $event)"
  >
    <template #body>
      <div class="flex flex-col gap-4 text-black">
        <h2 class="text-2xl font-bold leading-tight">
          {{ t('patterns.add_to_stash_modal.title') }}
        </h2>
        <ul class="list-inside list-disc space-y-1 text-sm">
          <li>{{ t('patterns.add_to_stash_modal.benefit_1') }}</li>
          <li>{{ t('patterns.add_to_stash_modal.benefit_2') }}</li>
          <li>{{ t('patterns.add_to_stash_modal.benefit_3') }}</li>
        </ul>
        <div class="flex flex-col items-center gap-3">
          <p
            v-if="error"
            class="w-full text-xs font-semibold text-error"
            role="alert"
          >
            {{ error }}
          </p>
          <ButtonText
            theme="primary"
            size="lg"
            full-width
            class="justify-center"
            :loading="loading"
            @click="emit('save-to-stash')"
          >
            {{ t('patterns.add_to_stash_modal.cta') }}
            <template #icon>
              <IconChevron direction="right" class="shrink-0" />
            </template>
          </ButtonText>
          <button
            type="button"
            class="inline-flex items-center gap-1 font-bold text-primary hover:text-primary-600 hover:underline disabled:pointer-events-none disabled:opacity-50"
            :disabled="loading"
            @click="emit('just-pdf')"
          >
            {{ t('patterns.add_to_stash_modal.just_pdf') }}
            <IconDownload
              class="size-6 shrink-0 font-bold"
              aria-hidden="true"
            />
          </button>
        </div>
      </div>
    </template>
  </Modal>
</template>
